import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { rides } from '../data/rides';
import { formatPrice } from '../utils/format';
interface BookingSectionProps {
  onBook: (rideId: string | null) => void;
}
export function BookingSection({
  onBook
}: BookingSectionProps) {
  const {
    t,
    l
  } = useLanguage();
  const b = t.booking;
  const locale = t.meta.locale;
  return <section id="booking" aria-labelledby="booking-title" className="scroll-mt-16 bg-cream py-20 lg:py-28" data-id="element-40" data-mp="2aiz3bh1kszaf">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:gap-16 lg:px-8" data-id="element-41" data-mp="25k4adm9w9ucl">
        <div className="lg:col-span-5" data-id="element-42" data-mp="2jfgegk9xwx66">
          <h2 id="booking-title" className="font-serif text-4xl font-bold text-bark md:text-5xl" data-id="element-43" data-mp="2ehy7gzfhgs0t">
            {b.title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-bark/75" data-id="element-44" data-mp="p41oc2d0ovpw">{b.intro}</p>

          <ol className="mt-10 space-y-6" data-id="element-45" data-mp="k5i0txirzbvf">
            {b.steps.map((step, i) => <li key={step.title} className="flex gap-4" data-id="element-46" data-mp="3tx7lnrevu7t5" data-mpi={i}>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-bark text-sm font-bold text-cream" aria-hidden="true" data-id="element-47" data-mp="3tulcxog99m9c">
                  {i + 1}
                </span>
                <div data-id="element-48" data-mp="cgq1nbssaedg">
                  <p className="font-serif text-lg font-bold text-bark" data-id="element-49" data-mp="ch99u0smtoea">{step.title}</p>
                  <p className="mt-0.5 leading-relaxed text-bark/70" data-id="element-50" data-mp="gh062k0xgwq7">{step.text}</p>
                </div>
              </li>)}
          </ol>

          <ul className="mt-10 space-y-2 border-t border-line pt-6" data-id="element-51" data-mp="qfz7pin9zs3p">
            {b.assurances.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-bark/80" data-id="element-52" data-mp="vf2cd1zcfwb5">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-moss" aria-hidden="true" data-id="element-53" data-mp="2s7lz3lb2xp0p" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="lg:col-span-7" data-id="element-54" data-mp="2p5hjfnd1q2z2">
          <div className="rounded-xl bg-linen p-2" data-id="element-55" data-mp="2p6isxneeyheo">
            <div className="rounded-lg border border-dashed border-saddle/40 p-5 sm:p-7" data-id="element-56" data-mp="2p7aowzbxah5h">
              <h3 className="font-serif text-2xl font-bold text-bark" data-id="element-57" data-mp="2k8r3r155l9e6">{b.chooseTitle}</h3>
              <ul className="mt-5 divide-y divide-line" data-id="element-58" data-mp="2z1kiulgijnib">
                {rides.map(ride => <li key={ride.id} className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3 py-4" data-id="element-59" data-mp="2u6ncjmambs94">
                    <div className="min-w-0 flex-1" data-id="element-60" data-mp="381za01g5rwtq">
                      <p className="font-serif text-lg font-bold text-bark" data-id="element-61" data-mp="334h6iqkwu9t4">{l(ride.title)}</p>
                      <p className="text-sm text-bark/65" data-id="element-62" data-mp="3ht3o6yy0fdni">
                        {l(ride.level)} · {ride.durationMin} {t.rides.min} · {t.routes[ride.route]}
                      </p>
                    </div>
                    <div className="flex items-center gap-5" data-id="element-63" data-mp="3qvcv7eu2kow5">
                      <p className="whitespace-nowrap text-right" data-id="element-64" data-mp="3mtrlg2cu0qq6">
                        <span className="font-serif text-xl font-bold text-bark" data-id="element-65" data-mp="3mreu4yl6p40g">{formatPrice(ride.price, locale)}</span>
                        <span className="block text-xs text-bark/60" data-id="element-66" data-mp="eaz0egd6sfo3">{ride.groupSize ? t.rides.perGroup : t.rides.perRider}</span>
                      </p>
                      <button type="button" onClick={() => onBook(ride.id)} className="whitespace-nowrap rounded-full bg-saddle px-5 py-2.5 text-sm font-bold text-cream transition-colors duration-150 hover:bg-leather focus:outline-none focus-visible:ring-2 focus-visible:ring-hay" data-id="element-67" data-mp="b6ecyclunmg">
                        {b.book}
                      </button>
                    </div>
                  </li>)}
              </ul>
              <button type="button" onClick={() => onBook(null)} className="mt-4 inline-flex items-center gap-2 font-bold text-saddle underline-offset-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-hay" data-id="element-68" data-mp="3hpl7ystn2lww">
                {b.allTimes}
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-69" data-mp="ax6ah39i78to" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}